export default __webpack_public_path__ + "static/media/MCCIA.3cc59cf9.png";